import React, { useEffect, useState } from 'react';
import Swal from 'sweetalert2';
import moment from 'moment'; // Recommended for clean date formatting
import { auth, db } from '../../firebase';
import "../../App.css";
import { collection, query, orderBy, onSnapshot, getDoc, doc, limit } from 'firebase/firestore';

export default function Logindetails() {
    const Toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer);
            toast.addEventListener('mouseleave', Swal.resumeTimer);
        }
    });

    const [userData, setUserData] = useState(null);
    const [loadincount, setloadincount] = useState(true);
    const [logindetails, setlogindetails] = useState([]);
    const [filteredDetails, setFilteredDetails] = useState([]); // Separate state for filtering
    const [searchText, setsearchText] = useState("");

    // 1. Fixed Infinite Loop: Added empty dependency array so auth listener registers only once
    useEffect(() => {
        const unsubscribe = auth.onAuthStateChanged((user) => {
            setUserData(user);
        });
        return () => unsubscribe(); // Clean up listener on unmount
    }, []);

    // 2. Trigger fetch check when userData changes
    useEffect(() => {
        if (userData && loadincount) {
            fetchPropid();
        }
    }, [userData, loadincount]);

    // 3. Local filtering logic that preserves the original logindetails array
    useEffect(() => {
        if (searchText === '') {
            setFilteredDetails(logindetails);
        } else {
            const searchLower = searchText.toUpperCase();
            const filtered = logindetails.filter((item) =>
                item.data.username?.toUpperCase().includes(searchLower)
            );
            setFilteredDetails(filtered);
        }
    }, [searchText, logindetails]);

    const fetchPropid = async () => {
        try {
            const docRef = doc(db, "users", userData.uid);
            const docSnap = await getDoc(docRef);
            if (docSnap.exists()) {
                fetchRealtimeLogins();
                setloadincount(false);
            }
        } catch (error) {
            console.error("Error verifying profile layout role:", error);
        }
    };

    const fetchRealtimeLogins = () => {
        try {
            const q = query(collection(db, 'logindetails'), orderBy('createdTime', 'desc'), limit(2000));
            
            // Using live real-time synchronization updates
            const unsubscribe = onSnapshot(q, (querySnapshot) => {
                const fetchedLogs = querySnapshot.docs.map(doc => ({
                    id: doc.id,
                    data: doc.data()
                }));
                setlogindetails(fetchedLogs);
            }, (error) => {
                Toast.fire({ icon: "error", title: error.message });
            });

            return unsubscribe;
        } catch (error) {
            Toast.fire({ icon: "error", title: error.message });
        }
    };

    // Helper function to render timestamps safely without crashing React
    const formatLoginTime = (createdTime) => {
        if (!createdTime) return "N/A";
        
        // Check if it's a Firestore Timestamp object with toDate()
        if (typeof createdTime.toDate === 'function') {
            return moment(createdTime.toDate()).format('DD-MM-YYYY hh:mm:ss A');
        }
        // If it's already a JS Date or ISO string
        if (createdTime instanceof Date || typeof createdTime === 'string') {
            return moment(createdTime).format('DD-MM-YYYY hh:mm:ss A');
        }
        
        return "Invalid Date";
    };

    return (
        <div>
            <div className="content-wrapper">
                <br />
                <section className="content">
                    <div className="container-fluid">
                        <button className="btn btn-secondary" style={{ float: "right", textTransform: "uppercase" }} >
                            || Login Details ||
                        </button>
                        <br /><br /><br />
                        <div className="card card-primary card-outline ex1">
                            <div className="p-1">
                                &nbsp;&nbsp;
                                <input 
                                    type="search" 
                                    value={searchText} 
                                    onChange={(e) => setsearchText(e.target.value)}
                                    className='form-control col-sm-4' 
                                    placeholder='Type here to search username...' 
                                />
                                &nbsp;
                            </div>
                            <div className="card-body table-responsive p-0">
                                <table className="table table-bordered table-hover table-striped table-head-fixed">
                                    <thead>
                                        <tr>
                                            <th>Sr No</th>
                                            <th>User Name</th>
                                            <th>Login Time</th>
                                            <th>Platform</th>
                                            <th>Screen Ratio</th>
                                            <th>User Agent</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {filteredDetails.length > 0 ? (
                                            filteredDetails.map((item, index) => (
                                                <tr key={item.id || index}>
                                                    <td width="80">{index + 1}</td>
                                                    <td>{item.data.username || "Unknown"}</td>
                                                    {/* CRITICAL FIX: Safe conversion handling executed here */}
                                                    <td>{formatLoginTime(item.data.createdTime)}</td>
                                                    <td>{item.data.systemDetails?.platform || "N/A"}</td>
                                                    <td>
                                                        {item.data.systemDetails?.screenHeight || "0"} X {item.data.systemDetails?.screenWidth || "0"}
                                                    </td>
                                                    <td style={{ maxWidth: '300px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={item.data.systemDetails?.userAgent}>
                                                        {item.data.systemDetails?.userAgent || "N/A"}
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="6" className="text-center">No login histories matched this cycle index.</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    );
}